export const Actions = {
    CALL_STARTING: 'CALL_STARTING',
    CALL_FINISHED: 'CALL_FINISHED',
};

export const callStarting = ({ method, endpoint, seq, when }: { method: string; endpoint: string; seq: number; when: Date }) => ({
    type: Actions.CALL_STARTING,
    payload: {
        method,
        endpoint,
        seq,
        when,
    },
});
export const callFinished = ({ seq, when }: { seq: number; when: Date }) => ({
    type: Actions.CALL_FINISHED,
    payload: {
        seq,
        when,
    },
});
